import { Grid } from "@mui/material";
import LabeledValue from "@/components/LabeledValue";
import {
  GROUP_FIELDS_LABEL,
  GROUP_FIELDS_SECTION,
  GROUP_UNCONFIGURED_VALUE,
} from "../group-visit-constant";
import { GroupDetail } from "../group-visit-types";
import DetailCard from "./DetailCard";

export type TherapistCardProps = {
  /** Chosen group; placeholders show until one is picked. */
  group?: GroupDetail;
};

/** Read-only Therapist and Co-Facilitator of the chosen group. */
const TherapistCard = ({ group }: TherapistCardProps) => (
  <DetailCard title={GROUP_FIELDS_SECTION.THERAPIST}>
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <LabeledValue
          label={GROUP_FIELDS_LABEL.therapist}
          value={group?.primaryTherapistName || GROUP_UNCONFIGURED_VALUE}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <LabeledValue
          label={GROUP_FIELDS_LABEL.coFacilitator}
          value={group?.coTherapistName || GROUP_UNCONFIGURED_VALUE}
        />
      </Grid>
    </Grid>
  </DetailCard>
);

export default TherapistCard;
